import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

const IAAssistenteRH = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesAIAgent = [
    {
      id: 1,
      title: 'iaAssistenteRh_page.relatedCases.items.hubDeIa.title',
      description: 'iaAssistenteRh_page.relatedCases.items.hubDeIa.description',
      icon: '',
      url: 'hub-de-ia',
    },
    {
      id: 2,
      title: 'iaAssistenteRh_page.relatedCases.items.leitorDePedidos.title',
      description: 'iaAssistenteRh_page.relatedCases.items.leitorDePedidos.description',
      icon: '',
      url: 'leitor-de-pedidos',
    },
    {
      id: 3,
      title: 'iaAssistenteRh_page.relatedCases.items.iaAssistenteDeManutencao.title',
      description:
        'iaAssistenteRh_page.relatedCases.items.iaAssistenteDeManutencao.description',
      icon: '',
      url: 'ia-assistente-de-manutencao',
    },
    {
      id: 5,
      title: 'iaAssistenteRh_page.relatedCases.items.customerInsights.title',
      description: 'iaAssistenteRh_page.relatedCases.items.customerInsights.description',
      icon: '',
      url: 'customer-insights',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('iaAssistenteRh_page.relatedCases.cta')

    trackCtaClick({
      cta_name: 'ia_case_related_case_click',
      cta_location: 'ia_case',
      page_name: 'ia_assistente_rh',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container DataCases">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('iaAssistenteRh_page.header.title')}</h2>
        </div>
        <div className="image-container">
          <img
            src="/assets/Cases/DataCases/notebook-datacase2.png"
            alt={t('iaAssistenteRh_page.header.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h3 className="NoBorder">
            {t('iaAssistenteRh_page.sections.challenge.title')}
          </h3>
          <ul>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item1')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item2')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item3')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item4')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item5')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item6')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item7')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item8')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item9')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item10')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item11')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item12')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item13')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item14')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item15')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item16')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item17')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item18')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item19')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item20')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item21')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item22')}</li>
            <li>{t('iaAssistenteRh_page.sections.challenge.items.item23')}</li>
          </ul>

          <hr />

          <h3>{t('iaAssistenteRh_page.sections.approach.title')}</h3>
          <ul>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item1')}</li>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item2')}</li>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item3')}</li>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item4')}</li>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item5')}</li>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item6')}</li>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item7')}</li>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item8')}</li>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item9')}</li>
            <li>{t('iaAssistenteRh_page.sections.approach.items.item10')}</li>
          </ul>

          <hr />

          <h3>{t('iaAssistenteRh_page.sections.result.title')}</h3>
          <ul>
            <li>{t('iaAssistenteRh_page.sections.result.items.item1')}</li>
            <li>{t('iaAssistenteRh_page.sections.result.items.item2')}</li>
            <li>{t('iaAssistenteRh_page.sections.result.items.item3')}</li>
            <li>{t('iaAssistenteRh_page.sections.result.items.item4')}</li>
            <li>{t('iaAssistenteRh_page.sections.result.items.item5')}</li>
          </ul>

          {/*
          <div className="DataHashtag">
            <button>Data Engineering</button>
            <button>GEN IA</button>
            <button>Full Stack development</button>
            <button>UX</button>
          </div>
          */}
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('iaAssistenteRh_page.relatedCases.title')}</h2>
        <span className="subtitle">{t('iaAssistenteRh_page.relatedCases.subtitle')}</span>

        <Pagination data={casesAIAgent} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="icon">{caseItem.icon}</span>
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('iaAssistenteRh_page.relatedCases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default IAAssistenteRH
